import React from 'react'
import "./Hamburger.css"

function Hamburger({openBurger,setOpenBurger}) {
  return (
    <button aria-label="Menu" className='hamburger' onClick={()=> setOpenBurger(!openBurger)}>
        <div className={openBurger ? 'line1 active' : 'line1' }></div>
        <div className={openBurger ? 'line2 active' : 'line2' }></div>
    </button>
  )
}

export default Hamburger